"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverShow = serverShow;
exports.clientShow = clientShow;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class3, _descriptor8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var OrderHistory = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(OrderHistory, _Component2);

  var _super2 = _createSuper(OrderHistory);

  function OrderHistory() {
    var _this3;

    babelHelpers.classCallCheck(this, OrderHistory);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this3, "orderList", _descriptor8, babelHelpers.assertThisInitialized(_this3));
    return _this3;
  }

  babelHelpers.createClass(OrderHistory, [{
    key: "render",
    value: function render() {
      if (!this.orderList.length) {
        return /*#__PURE__*/_react.default.createElement("p", {
          style: {
            fontStyle: 'italic',
            textAlign: 'center'
          }
        }, "There have been no orders for this facility created on this site");
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container card-list"
      }, this.orderList.map(function (order) {
        return /*#__PURE__*/_react.default.createElement(OrderLine, _extends({
          key: order.id
        }, order));
      }));
    }
  }]);
  return OrderHistory;
}(_react.Component), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "orderList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class3);
exports.default = OrderHistory;
var OrderLine = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(OrderLine, _Component);

  var _super = _createSuper(OrderLine);

  function OrderLine() {
    var _this;

    babelHelpers.classCallCheck(this, OrderLine);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "orderNumber", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "orderDate", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "orderedBy", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "poRefNumber", _descriptor4, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "amount", _descriptor5, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor6, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "url", _descriptor7, babelHelpers.assertThisInitialized(_this));
    _this.state = {
      isReorder: false
    };
    return _this;
  }

  babelHelpers.createClass(OrderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card product past-order-item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "top order-number",
        onClick: this.showOrder
      }, /*#__PURE__*/_react.default.createElement("h3", null, this.orderNumber)), /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "middle without-bottom",
        onClick: this.showOrder
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("h3", null, new Date(this.orderDate * 1000).format('F j, Y')), /*#__PURE__*/_react.default.createElement("p", null, this.poRefNumber ? "PO ".concat(this.poRefNumber, " - ") : '', "Ordered by ", this.orderedBy))), /*#__PURE__*/_react.default.createElement("div", {
        className: "bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "quantity"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.formatPrice(this.amount))), /*#__PURE__*/_react.default.createElement("div", {
        className: "price"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.showOrder,
        className: "btn btn-default"
      }, "View")), /*#__PURE__*/_react.default.createElement("div", {
        className: "total"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.reOrder,
        "data-spin": this.state.isReorder ? 'true' : void 0,
        className: _classList.default.join('btn btn-default', this.state.isReorder ? 'spinning' : '')
      }, "Re-Order")))));
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);
      var x = amount.split('.');
      var whole = x[0],
          dec = x[1];
      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3)).concat(dd);
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }, {
    key: "showOrder",
    value: function showOrder() {
      require('layouts/SiteLayout').default.current.navigate(this.url);
    }
  }, {
    key: "reOrder",
    value: function reOrder() {
      var _this2 = this;

      if (this.state.isReorder) {
        return;
      }

      this.setState({
        isReorder: true
      }, function () {
        (0, _fetch.default)('data/cart/reorder', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order: _this2.id
          })
        }).then(function (d) {
          return d.json();
        }).then(function (d) {
          require('components/SiteNavigation').default.cartUpdated();

          require('layouts/SiteLayout').default.current.navigate(d.target);
        });
      });
    }
  }]);
  return OrderLine;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderDate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderedBy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "poRefNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "amount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "url", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showOrder"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "reOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "reOrder"), _class.prototype)), _class);

function serverShow(page, orderList) {
  return "\n\t\t<div class='inner-content container'>".concat(require('react-dom/server').renderToString( /*#__PURE__*/_react.default.createElement(OrderHistory, {
    orderList: orderList
  })), "</div>\n\t\t").concat(page.inlineScriptArgs(function (orderList) {
    require('Orders').clientShow(this.querySelector('.inner-content'), orderList);
  }, orderList), "\n\t");
}

function clientShow(element, orderList) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(OrderHistory, {
    orderList: orderList
  }), element);
}